import { getKeyStageDisplayLabel } from "./utils/getKeyStageDisplayLabel/getKeyStageDisplayLabel";
import { getResourceTypeDisplayLabel } from "./utils/getResourceTypeDisplayLabel/getResourceTypeDisplayLabel";
import { getThreadDisplayLabel } from "./utils/getThreadDisplayLabel/getThreadDisplayLabel";
import { sortKeyStageOptions } from "./utils/sortKeyStageOptions/sortKeyStageOptions";

export const ResourceHelper = {
  getTypeLabel: getResourceTypeDisplayLabel,
  getKeyStageLabel: getKeyStageDisplayLabel,
  getThreadLabel: getThreadDisplayLabel,
  sortKeyStageOptions,
};
